import html2canvas from 'html2canvas';

export const exportChartToPng = (chartId, filename = 'chart.png') => {
  const chartElement = document.getElementById(chartId);
  if (!chartElement) {
    console.error(`Элемент с id=${chartId} не найден`);
    return;
  }

  html2canvas(chartElement).then((canvas) => {
    const link = document.createElement('a');
    link.download = filename;
    link.href = canvas.toDataURL('image/png');
    link.click();
  }).catch((err) => {
    console.error('Ошибка при экспорте графика:', err);
  });
};
